import { Home } from '../components/Home';

export const homeRoute = {
  name: 'home',
  path: '/',
  component: Home,
  resources: [],
};
